import React, { type Ref } from 'react';
import { Button } from 'antd';

import { getFormattedPrice } from '@tools/utils/common.tsx';

export interface PosCheckoutActionsProps {
  canWriteQuotes: boolean;
  hasLines: boolean;
  isProcessingCheckout: boolean;
  isSavingQuoteChanges: boolean;
  loadedQuoteId: number | null;
  disableConfirmAction: boolean;
  total: number;
  currency: string;
  confirmButtonRef?: Ref<HTMLButtonElement>;
  onSaveQuote: () => void;
  onConfirm: () => void;
}

export const PosCheckoutActions: React.FC<PosCheckoutActionsProps> = ({
  canWriteQuotes,
  hasLines,
  isProcessingCheckout,
  isSavingQuoteChanges,
  loadedQuoteId,
  disableConfirmAction,
  total,
  currency,
  confirmButtonRef,
  onSaveQuote,
  onConfirm,
}) => (
  <div className="pos-checkout-panel__actions">
    <Button onClick={onSaveQuote} disabled={!canWriteQuotes || !hasLines || isProcessingCheckout || isSavingQuoteChanges}>
      {loadedQuoteId != null ? 'Guardar cambios' : 'Guardar presupuesto'}
    </Button>
    <Button type="primary" onClick={onConfirm} disabled={disableConfirmAction} ref={confirmButtonRef}>
      Cobrar {getFormattedPrice(total, currency)}
    </Button>
  </div>
);

export default PosCheckoutActions;
